import { FC, Fragment, useState } from 'react';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatPriceFlight, getPassengerStr } from 'utils/flight/flight';
import { useTranslation } from 'react-i18next';
import { FlightDetails } from 'ts/flight/interfaces/FlightDetailsResponse';
import { faChevronCircleDown, faChevronCircleUp } from '@fortawesome/free-solid-svg-icons';
import { formatPrice } from 'utils/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface PassengerListProps {
  flight: FlightDetails;
}

const PassengerList: FC<PassengerListProps> = ({ flight }) => {
  const [t] = useTranslation();

  const [shownDetailsIndexes, setShownDetailsIndexes] = useState(-1);
  const onClickChevron = (index: number) => {
    setShownDetailsIndexes(shownDetailsIndexes === -1 ? index : -1);
  };

  return (
    <Fragment>
      {flight.flightPricesByPDT.map((passenger, index) => (
        <div className="mb-10" key={index}>
          <span className="flex-between">
            <span>
              <span className="text-bold">{getPassengerStr(t, passenger.paxPDT)}: </span>
              <span className="mr-5">{passenger.quantity}</span>
              <Tooltip
                position="top"
                children={
                  <FontAwesomeIcon
                    icon={
                      (index === shownDetailsIndexes
                        ? faChevronCircleUp
                        : faChevronCircleDown) as any
                    }
                    onClick={() => onClickChevron(index)}
                  />
                }
                content={t('flight.show_details')}
              />
            </span>
            {formatPrice(
              Math.round(passenger.grossAndTaxWithMarkup.value),
              passenger.grossAndTaxWithMarkup.currency
            )}
          </span>
          <div>
            {index === shownDetailsIndexes && (
              <div className="mt-5">
                {t('basis')}{' '}
                <span className="text-bold">
                  {formatPriceFlight(passenger.grossWithMarkup, passenger.quantity)}{' '}
                </span>{' '}
                + {t('taxes')}{' '}
                <span className="text-bold">
                  {formatPriceFlight(passenger.tax, passenger.quantity)}{' '}
                </span>{' '}
                = {t('price')}{' '}
                <span className="text-bold text-contrast">
                  {formatPriceFlight(passenger.grossAndTaxWithMarkup, passenger.quantity)}
                </span>
              </div>
            )}
          </div>
        </div>
      ))}
    </Fragment>
  );
};

export default withErrorBoundary(PassengerList, 'PassengerList');
